// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyCxkRWrR6mChjmUqLaQoWXhFL-ZWRpbL30",
    authDomain: "vidyarthi24-74010.firebaseapp.com",
    projectId: "vidyarthi24-74010",
    storageBucket: "vidyarthi24-74010.appspot.com",
    messagingSenderId: "345917506583",
    appId: "1:345917506583:web:b806be29199b05d9278852"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
